import {integrityProfGral} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadIntegrityProfGral(selection: any) {
  return useLoad(integrityProfGral, 'revision', {values: selection});
}

export default useLoadIntegrityProfGral;
